import { Component } from '@angular/core';

@Component({
  selector: 'app-assistance',
  templateUrl: './assistance.component.html',
  styleUrl: './assistance.component.scss'
})
export class AssistanceComponent {

}
